export default "__VITE_ASSET__BndeYqyV__";